module.exports = __webpack_public_path__ + "fonts/flexible-carnivore-ic.svg";